import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../components/registraction/Sidebar';
import Step1Company from '../../components/registraction/Step1Company';
import Step2Contact from '../../components/registraction/Step2Contact';
import Step3Industry from '../../components/registraction/Step3Industry';
import Step4Agreement from '../../components/registraction/Step4Agreement';
import Step5Review from '../../components/registraction/Step5Review';
import css from '../registration/FactoryRegistraction.module.css';
import MobileStepper from '../../components/registraction/MobileStepper';
import { signup, clearSignupError } from '../../ducks/auth.duck';

const FactoryRegistration = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  const { signupInProgress, signupError } = useSelector(state => state.auth);

  const nextStep = values => {
    if (values) {
      setFormData(prev => ({ ...prev, ...values }));
    }
    setCurrentStep(prev => prev + 1);
    // Scroll to top of form area on step change
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const prevStep = () => {
    dispatch(clearSignupError());
    setCurrentStep(prev => prev - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Used from Step5 "Edit" buttons to jump directly to a specific step.
  // Also clears any lingering signup error so the user starts fresh.
  const goToStep = step => {
    dispatch(clearSignupError());
    setCurrentStep(step);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = values => {
    // values here is the already-accumulated formData passed from Step5
    const allData = { ...formData, ...values };
    const nameParts = (allData.contactPersonName || '').trim().split(' ');
    const firstName = nameParts[0] || 'Factory';
    const lastName = nameParts.slice(1).join(' ') || 'User';

    const params = {
      email: allData.email,
      password: allData.password,
      firstName,
      lastName,
      publicData: {
        userType: 'factory',
        companyName: allData.companyName,
        businessLicense: allData.businessLicense,
        registrationNumber: allData.registrationNumber,
        province: allData.province,
        city: allData.city,
        factoryAddress: allData.factoryAddress,
        primaryIndustry: allData.primaryIndustry,
        secondaryIndustry: allData.secondaryIndustry,
        products: allData.products,
        capacity: allData.capacity,
        designation: allData.designation,
        phone: allData.phone,
        whatsapp: allData.whatsapp,
        wechat: allData.wechat,
      },
    };

    dispatch(signup(params))
      .then(() => history.push('/'))
      .catch(() => {});
  };

  return (
    <div className={css.main}>
      <Sidebar currentStep={currentStep} />
      <div className={css.content}>
        <MobileStepper currentStep={currentStep} />
        {currentStep === 1 && (
          <Step1Company nextStep={nextStep} initialValues={formData} />
        )}
        {currentStep === 2 && (
          <Step2Contact nextStep={nextStep} prevStep={prevStep} initialValues={formData} />
        )}
        {currentStep === 3 && (
          <Step3Industry nextStep={nextStep} prevStep={prevStep} initialValues={formData} />
        )}
        {currentStep === 4 && (
          <Step4Agreement nextStep={nextStep} prevStep={prevStep} initialValues={formData} />
        )}
        {currentStep === 5 && (
          <Step5Review
            prevStep={prevStep}
            goToStep={goToStep}
            formData={formData}
            onSubmit={handleSubmit}
            submitInProgress={signupInProgress}
            submitError={signupError}
          />
        )}
      </div>
    </div>
  );
};
FactoryRegistration.defaultProps = {
  className: null,
  rootClassName: null,
};

FactoryRegistration.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};
export default FactoryRegistration;
